import { Colors } from "@/enums/Colors";
import { Button, ListItemIcon, styled, Typography } from "@mui/material";
import CaretLeftLogo from "../../../assets/images/caret-left-logo.svg";

interface Props {
  handlePrevious: () => void;
  optionalAction?: () => void;
}

const StyledButton = styled(Button)(({ theme }) => ({
  zIndex: 1,
  backgroundColor: Colors.WHITE,
  color: Colors.BLACK,
  borderRadius: "1rem",
  minWidth: "8rem",
  padding: 0,
  height: "3.3125rem",
  textTransform: "none",
  "&:hover": {
    backgroundColor: Colors.WHITE,
  },
  [theme.breakpoints.down("md")]: {
    margin: 0,
  },
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const TextButton = styled(Typography)(({ theme }) => ({
  color: Colors.BLACK_151517,
  fontSize: ".75rem",
  fontWeight: "500",
  lineHeight: "1.125rem",
}));

export const PreviousButton = ({ handlePrevious }: Props) => {
  return (
    <StyledButton onClick={handlePrevious}>
      <ListItemIcon>
        <img src={CaretLeftLogo.src} />
      </ListItemIcon>
      <TextButton>Back to Company</TextButton>
    </StyledButton>
  );
};
